export const smartSearchPlaceholders = [
  'How do I make milkshakes?',
  'Tell me about fire safety in the restaurant.',
  'How do I clean the breading table?',
  'What is the hold time for grilled nuggets?',
  'Can you give me an overview of how to be the cow?',
  'Can you help me learn how to take payments in the drive-thru?',
];
